import React from "react";
import Icon from "../atoms/Icon";

const Modal = (props) => {
    return (<>
        <div
            className="bg-bg-blur justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none ">
            <div className="bg-main-blue-300 rounded-sm relative w-auto my-10 mx-auto ">
                {/* Modal container */}
                <div
                    className=" bg-transparent border-0 rounded-lg shadow-lg relative flex flex-col w-full outline-none focus:outline-none">
                    {/* Modal header */}
                    <div className="flex items-center justify-between py-5.5 px-7.5px text-white">
                        <h3 className="text-16 font-medium">{props.title}</h3>
                        {/* Close button */}
                        <button
                            className="p-1  bg-transparent mr-auto outline-none focus:outline-none"
                            onClick={props.closeModal}>
                <span
                    className="w-full bg-transparent flex flex-row items-center gap-2 text-white text-12   outline-none focus:outline-none  "
                    dir="rtl">
                  <span>
                    <Icon iconName={"forbidden-2"}/>
                  </span>
                  بستن
                </span>
                        </button>
                    </div>
                    {/* Modal content */}
                    <div className="rounded-sm bg-white mx-1 mb-1 p-3">
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    </>);
};

export default Modal;
